<template>
  <div >
    <a class="menu" v-on:click="nav('/index-en')">English</a>
    <h1>{{ msg }}</h1>
    <a >当前登录账号：{{ accountName + "@" + permission}}</a>
    <button v-show="hasLogin" class="logout" v-on:click="logout()">退出登录</button><br>
    <a>已绑定 URL/IP 地址：{{bindDappUrl}}</a><br><br>
    <a class="error-msg">{{errorMsg}}</a>
    <button v-show="!hasLogin" class="inputBtn" v-on:click="login()">登录</button>
    <form>
      <input v-show="hasLogin" class="inputTx" v-model="accountName" type="text" name="accountName" placeholder="输入 EOS 账号"/><br>
      <input v-show="hasLogin" class="inputTx" v-model="dappUrl" name="accountName" placeholder="输入 URL 或者 IP 地址"/><br>
      <input v-show="hasLogin" class="inputBtn" v-on:click="bindAccount(accountName,dappUrl)" type="button" v-model="bindMsg"/><br>
      <input v-show="hasBind" class="inputBtn" v-on:click="unbind(accountName)" type="button" v-model="unbindMsg"/><br>
    </form>
    <br><br>
    <div class="group">
      <a class="info2">
        1. 该项目是一个 DNS 的雏形，通过本页面的进行 EOS 账号和网站地址绑定。
      </a><br>
      <a class="info2">
        2. 用户可以在<a class="href" v-on:click="nav('/browser')">ENS 浏览器</a>进行访问，也可以通过安装<a href="https://github.com/EOSNameServe/ensProtocolParser" class="href">Chrome-插件</a>的形式进行访问已经绑定网站。
      </a>
    </div>
    <br><br>
    <a class="href" v-on:click="nav('/browser')">[ENS 浏览器]</a>
    <a href="https://github.com/EOSNameServe/ENS" class="href">[GitHub 项目介绍]</a>
    <a href="https://t.me/EOSNameServe" class="href">[Telegram]</a>
    <a href="https://github.com/EOSNameServe/ensProtocolParser" class="href">[Chrome-插件]</a>
    <a href="./agent/x-account.html" class="href">[购买 x 短账号]</a>
    <a href="http://eosnameswaps.com" class="href">[用 eosnameswaps 购买其他账号]</a>
    <a href="http://eoscontract.io" class="href">[用 eoscontract 购买其他账号]</a>
  </div>
</template>

<script>

import transcation from '@/HelperTrx'
import Eos from 'eosjs'

export default {
  name: 'Main',
  mounted(){
    ScatterJS.scatter.connect("ENSDapp").then(connected => {
      if(!connected) {
        return false;
      }
      const scatter = ScatterJS.scatter;
      const requiredFields = {accounts:[network]};
      return scatter.getIdentity(requiredFields);
    })
    .then(identity => {
      window.identity = identity;
      if ((identity.accounts != null && identity.accounts != undefined)
            && identity.accounts.length > 0){
        this.hasLogin = true;
        this.accountName = identity.accounts[0].name 
        this.permission = identity.accounts[0].authority;
      } else {
        this.hasLogin = false;
        this.accountName = "";
      }
      console.log("getId success");
    })
    .then(result => {
      return this.$http.post("https://api1.eosasia.one/v1/chain/get_table_rows",{
          scope:this.accountName,
          code:"enserve.bank",
          table:"enstables",
          json:"true"
      })
    })
    .then(response => {
        if(response.body.rows.length > 0){
          this.hasBind = true;
          this.bindDappUrl = response.body.rows[0].dapp
        } else {
          this.hasBind = false;
          this.bindDappUrl = "未绑定";
        }
      })
    .catch(error => {
      console.log("connect finish: " + error); 
      alert("connect finish:" + JSON.stringify( error ));
    });
  },
  methods:{
      bindAccount:function(accountName,dappUrl){
        if(!this.checkUrlOrIp(dappUrl) || this.invoking){
          return;
        }
        this.bindMsg = "正在唤起 Scatter ....";
        this.invoking = true;
        const eosOptions = { expireInSeconds:60 };
        const eos = scatter.eos(network, Eos, eosOptions);
        eos.transaction({
            actions: [{
                account: 'enserve.bank',
                name: 'binddapp',
                authorization: [{
                    actor: accountName,
                    permission: 'active',
                }],
                data: {
                    dapp: dappUrl,
                    account_name: accountName,
                },
            }]
        }, {
            blocksBehind: 3,
            expireSeconds: 60,
        })
        .then(data => {
            console.log(data);
            this.bindDappUrl = dappUrl;
            this.hasBind = true;
            this.bindMsg = "绑定";
            this.invoking = false;
            alert("Bind Success!!");
        })
        .catch( error => {
            this.bindMsg = "绑定";
            this.invoking = false;
            console.log(error);
            alert(JSON.stringify(error));
        }); 
      },
      unbind:function(accountName){
        if(this.invoking){
          return;
        }
        this.unbindMsg = "正在唤起 Scatter ....";
        this.invoking = true;
        const eosOptions = { expireInSeconds:60 };
        const eos = scatter.eos(network, Eos, eosOptions);
        eos.transaction({
          actions: [{
            account: 'enserve.bank',
            name: 'unbind',
            authorization: [{
                actor: accountName,
                permission: 'active'
            }],
            data: {
                account_name: accountName
            },
          }]
        }, {
            blocksBehind: 3,
            expireSeconds: 60,
        }).then(data => {
            console.log(data);
            this.bindDappUrl = '';
            this.dappUrl = '';
            this.hasBind = false;
            this.unbindMsg = '解除绑定';
            this.invoking = false;
            alert("Unbind Success!!");
        }).catch(error => {
            this.unbindMsg = '解除绑定';
            this.invoking = false;
            console.log(error);
            alert(JSON.stringify( error ));
        }); 
      },
      logout:function(){
        scatter.forgetIdentity().then(() => {
          alert("Logout Success!!");
          this.accountName = '';
          this.dapp = '';
          this.permission = '';
          this.hasLogin = false;
          this.hasBind = false;
          this.bindDappUrl = '';
        }).catch(error => {
            console.log(error);
            alert(JSON.stringify( error ));
        });;
      },
      login:function(){
        ScatterJS.scatter.connect("ENSDapp")
        .then(connected => {
          if(!connected) {
            return false;
          }
          const scatter = ScatterJS.scatter;
          const requiredFields = {accounts:[network]};
          return scatter.getIdentity(requiredFields)
        }).then(identity => {
          window.identity = identity;
          if ((identity.accounts != null && identity.accounts != undefined)
                && identity.accounts.length > 0){
            this.hasLogin = true;
            this.accountName = identity.accounts[0].name 
            this.permission = identity.accounts[0].authority;
          } else {
            this.hasLogin = false;
            this.accountName = "";
          }
          console.log("getId success");
        }).then(result => {
          return this.$http.post("https://api1.eosasia.one/v1/chain/get_table_rows",{
            scope:this.accountName,
            code:"enserve.bank",
            table:"enstables",
            json:"true"
          })
        })
        .then(response => {
          if(response.body.rows.length > 0){
            this.hasBind = true;
            this.bindDappUrl = response.body.rows[0].dapp
          } else {
            this.hasBind = false;
            this.bindDappUrl = "未绑定";
          }
        }).catch(error => {
          console.log("getId error: " + error);
          alert(JSON.stringify(error));
        });
      },
      checkUrlOrIp:function(accountName){
        var reURL = /^(https?):\/\/.+$/;
        if(!reURL.test(accountName)){
          this.errorMsg = "地址不符合格式，请以 http:// 或者 https:// 开始，并跟随任意 url 或者 ip 地址";
          return false;
        } else {
          this.errorMsg = '';
          return true;
        }
      },
      nav:function(path){
        this.$router.push(path);
      }
  },
  data () {
    return {
      msg: 'EOS Name Serve',
      accountName: '',
      dappUrl: '',
      bindDappUrl:'',
      permission: '',
      hasLogin: false,// 是否登录
      hasBind: false,// 是否绑定上 url
      invoking: false,// 判断 scatter 唤起状态
      errorMsg:'',// 错误信息
      bindMsg:"绑定",// 绑定按钮文字
      unbindMsg:"取消绑定"// 解绑按钮文字
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.group{
  text-align: left;
  width: 20em;
  margin: 0 auto
}
.info{
  color: #333;
}
.info2{
  color: #333;
  size: 6em;
}
.menu {
  color: #42b983;
  cursor:pointer;
  position: fixed;
  right: 0;
  top: 8%;
  width: 6em;
  margin-top: -2.5em;
}
h1{
  font-weight: normal;
}
.error-msg{
  color: red
}
.href{
  cursor:pointer;
  text-decoration: underline;
  margin-top: 100px;
  padding: 10px;
  color: rgb(3, 3, 3);
}
.logout{
  border: 1px solid rgb(75, 75, 75);
  border-radius: 5px;
}
.logout:hover{
  background-color: rgb(107, 107, 107);
  color: rgb(255, 255, 255);
}
.inputTx{
  border: 1px solid rgb(75, 75, 75);
  border-radius: 5px;
  padding: 10px;
  width: 240px;
  height: 20px;
  margin-top: 30px;
}
.inputTx:focus{
    border: 2px solid #333;
    outline: none;
}
.inputBtn{
  padding: 10px;
  margin-top: 30px;
  width: 300px;
  border: 1px solid rgb(75, 75, 75);
  border-radius: 5px;
}
.inputBtn:hover{
  background-color: rgb(107, 107, 107);
  color: rgb(255, 255, 255);
}
.inputBtn:focus{
  outline:none;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue